import { Form, InputGroup } from "react-bootstrap";
import PhoneInput from 'react-phone-input-2';
import { Controller } from "react-hook-form";
import Select from "react-select";
import { useEffect, useRef, useState } from "react";
import { IconX } from "@tabler/icons-react";
import { customStyles } from "../Utils/helpers/commonhelper";

// ---------------- TEXT ----------------
// export const Text = ({
//     name,
//     label_name,
//     rules,
//     isRequired,
//     isImportant,
//     control,
//     label_type // 'text', 'textarea', 'number', 'monetary', 'address'
// }) => {
//     const renderInput = (field, fieldState) => {
//         const commonProps = {
//             placeholder: label_name,
//             value: field.value,
//             onChange: (e) => field.onChange(e.target.value),
//             onBlur: field.onBlur,
//             className: fieldState.error ? 'is-invalid' : ''
//         };

//         switch (label_type) {
//             case 'largetext':
//             case 'address':
//                 return <Form.Control as="textarea" rows={4} {...commonProps} />;
//             case 'numerical':
//                 return (
//                     <Form.Control
//                         type="text"
//                         {...commonProps}
//                         onChange={(e) => {
//                             const value = e.target.value.replace(/[^0-9]/g, '');
//                             field.onChange(value === '' ? '' : value);
//                         }}
//                     />
//                 );
//             case 'monetary':
//                 return (
//                     <InputGroup>
//                         <InputGroup.Text style={{ backgroundColor: '#f8f9fa', border: '1px solid #ced4da' }}>₹</InputGroup.Text>
//                         <Form.Control
//                             type="number"
//                             placeholder="0.00"
//                             value={field.value || ''}
//                             onChange={(e) => field.onChange(e.target.value === '' ? '' : Number(e.target.value))}
//                             onBlur={field.onBlur}
//                             className={fieldState.error ? 'is-invalid' : ''}
//                             step="0.01"
//                             min="0"
//                         />
//                     </InputGroup>
//                 );
//             case 'text':
//             default:
//                 return <Form.Control type="text" {...commonProps} />;
//         }
//     };

//     return (
//         <Controller
//             name={name}
//             control={control}
//             rules={rules}
//             defaultValue=""
//             render={({ field, fieldState }) => (
//                 <Form.Group className="mb-3 focus-z-index position-relative">
//                     <Form.Label>
//                         {label_name} {isRequired && <span className="text-danger ms-1">*</span>}
//                     </Form.Label>
//                     <InputGroup>{renderInput(field, fieldState)}</InputGroup>
//                     {fieldState.error && <p style={{ fontSize: "12px" }} className="text-danger mt-1">{fieldState.error.message}</p>}
//                 </Form.Group>
//             )}
//         />
//     );
// };

export const Text = ({
    name,
    label_name,
    rules,
    isRequired,
    isImportant,
    control,
    label_type
}) => {

    const renderInput = (field, fieldState, labelType) => {
        switch (labelType) {
            case 'largeText':
            case 'address':
                return (
                    <Form.Control
                        as="textarea"
                        rows={4}
                        placeholder={label_name}
                        value={field?.value}
                        onChange={(e) => field?.onChange(e.target.value)}
                        onBlur={field?.onBlur}
                    />
                );

            case 'numerical':
                return (
                    <Form.Control
                        type="text"
                        placeholder={label_name}
                        value={field?.value}
                        onChange={(e) => {
                            const value = e.target.value.replace(/[^0-9]/g, '');
                            field.onChange(value === '' ? '' : value);
                        }}
                        onBlur={field?.onBlur}
                    // className={fieldState?.error ? "is-invalid" : ""}
                    />
                );

            // case 'monetary':
            //     return (
            //         <InputGroup>
            //             <InputGroup.Text>₹</InputGroup.Text>
            //             <Form.Control
            //                 type="number"
            //                 placeholder="0.00"
            //                 value={field.value || 0}
            //                 onChange={(e) =>
            //                     field.onChange(e.target.value === "" ? "" : Number(e.target.value))
            //                 }
            //                 onBlur={field.onBlur}
            //                 // className={fieldState.error ? "is-invalid" : ""}
            //                 step="0.01"
            //                 min="0"
            //             />
            //         </InputGroup>
            //     );

            case 'monetary':
                return (
                    <InputGroup>
                        <InputGroup.Text>₹</InputGroup.Text>
                        <Form.Control
                            type="number"
                            placeholder="0.00"
                            value={(field.value === undefined || field.value === null) ? "" : field.value}
                            onChange={(e) => {
                                const val = e.target.value;
                                field.onChange(val === "" ? "" : Number(val));
                            }}
                            onBlur={field.onBlur}
                            className={fieldState?.error ? "is-invalid" : ""}
                            step="0.01"
                        />
                    </InputGroup>
                );

            case 'text': return (
                <Form.Control
                    type="text"
                    placeholder={label_name}
                    value={field?.value}
                    onChange={(e) => field?.onChange(e.target.value)}
                    onBlur={field?.onBlur}
                // className={fieldState?.error ? "is-invalid" : ""}
                />
            );
            default:
                return (
                    <Form.Control
                        type="text"
                        placeholder={label_name}
                        value={field?.value}
                        onChange={(e) => field?.onChange(e.target.value)}
                        onBlur={field?.onBlur}
                    />
                );
        }
    };

    return (
        <Controller
            name={name}
            control={control}
            // rules={rules}
            rules={isRequired === true || isRequired === "yes" ? rules : {}}
            defaultValue=""
            render={({ field, fieldState: { error } }) => (
                <Form.Group className="mb-3 focus-z-index position-relative">
                    <Form.Label>
                        {isRequired && isImportant ? (
                            <>
                                <span className="text-danger">{label_name}</span>
                                <span className="text-danger ms-1">*</span>
                                <span>
                                    <i className="bi bi-exclamation-triangle text-warning ps-1"></i>
                                </span>
                            </>
                        ) : isImportant ? (
                            <>
                                <span className="text-danger">
                                    {label_name}
                                </span>
                                <span> <i className="bi bi-exclamation-triangle text-warning ps-1"></i></span>
                            </>
                        ) : isRequired ? (
                            <>
                                {label_name}
                                <span className="text-danger ms-1">*</span>
                            </>
                        ) : (
                            label_name
                        )}
                    </Form.Label>

                    <InputGroup>{renderInput(field, error, label_type)}</InputGroup>
                    {isRequired && error && <>
                        <p
                            style={{ fontSize: "12px" }}
                            className="text-danger mt-1"
                        >
                            {error?.message || ""}
                        </p>
                    </>
                    }
                </Form.Group>
            )}
        />
    );
};

// ---------------- SELECT ----------------
export const SelectOpt = ({
    name,
    label_name,
    isRequired = false,
    label_type,
    isImportant,
    options,
    control,
    rules
}) => {
    const getProcessedOptions = () => {
        if (!options) return [];

        switch (label_type) {
            case "user":
                return Array.isArray(options)
                    ? options
                    : [];
            case "person":
                return Array.isArray(options)
                    ? options.map((p) => ({ value: p.contact_id, label: p.contact_name }))
                    : [];
            case "organization":
                return Array.isArray(options)
                    ? options.map((o) => ({ value: o.company_id, label: o.company_name }))
                    : [];
            default:
                try {
                    const parsed = Array.isArray(options)
                        ? options
                        : JSON.parse(options);

                    return (
                        parsed
                            ?.sort((a, b) => Number(a.sequence || 0) - Number(b.sequence || 0))
                            ?.map((opt) => ({ value: opt.option, label: opt.option })) || []
                    );
                } catch {
                    return [];
                }
        }
    };

    const processedOptions = getProcessedOptions();

    const getCurrentValue = (fieldValue) =>
        processedOptions.find((opt) => opt.value === fieldValue) || null;

    const handleChange = (selected, onChange) =>
        onChange(selected?.value || "");

    return (
        <Controller
            name={name}
            control={control}
            // rules={isRequired ? { required: `${label_name} is required` } : {}}
            rules={isRequired === true || isRequired === "yes" ? rules : {}}
            render={({ field, fieldState: { error } }) => (
                <Form.Group className="mb-3 focus-z-index position-relative">

                    <Form.Label>
                        {isRequired && isImportant ? (
                            <>
                                <span className="text-danger">{label_name}</span>
                                <span className="text-danger ms-1">*</span>
                                <span> <i className="bi bi-exclamation-triangle text-warning ps-1"></i></span>
                            </>
                        ) : isImportant ? (
                            <>
                                <span className="text-danger">{label_name}</span>
                                <span> <i className="bi bi-exclamation-triangle text-warning ps-1"></i></span>
                            </>
                        ) : isRequired ? (
                            <>
                                {label_name}
                                <span className="text-danger ms-1">*</span>
                            </>
                        ) : (
                            label_name
                        )}
                    </Form.Label>
                    <Select
                        styles={customStyles}
                        className="input-box-select"
                        options={processedOptions}
                        value={getCurrentValue(field?.value)}
                        onChange={(sel) => handleChange(sel, field?.onChange)}
                        onBlur={field?.onBlur}
                        isClearable
                        isSearchable
                        placeholder={`Select ${label_name}`}
                        classNamePrefix="react-select"
                    />
                    {/* {isRequired && fieldStaterror && <div className="invalid-feedback d-block" style={{ fontSize: "12px" }}>{fieldState?.error?.message}</div>} */}

                    {isRequired && error && <>
                        <p
                            style={{ fontSize: "12px" }}
                            className="text-danger mt-1"
                        >
                            {error?.message || ""}
                        </p>
                    </>
                    }

                </Form.Group>
            )}
        />
    );
};

// ---------------- DATE ----------------
export const DateField = ({
    name,
    label_name,
    rules,
    isRequired,
    isImportant,
    control,
    label_type,
    isDisabled
}) => {
    const renderDateInput = (field, fieldState, labelType) => {
        // console.log(fieldState,labelType, field)
        // const commonProps = {
        //     onBlur: field.onBlur,
        // };
        if (labelType === 'date range') {
            return (
                <div className="d-flex gap-2 align-items-center">
                    <Form.Control
                        type="date"
                        value={field.value?.start || ''}
                        onChange={(e) => field.onChange({ ...field.value, start: e.target.value })}
                        disabled={isDisabled}
                    // {...commonProps}
                    />
                    <span className="text-muted">to</span>
                    <Form.Control
                        type="date"
                        value={field.value?.end || ''}
                        onChange={(e) => field.onChange({ ...field.value, end: e.target.value })}
                        disabled={isDisabled}
                    // {...commonProps}
                    />
                </div>
            );
        }

        return (
            <Form.Control
                type="date"
                value={field.value || ''}
                onChange={(e) => field.onChange(e.target.value)}
            // {...commonProps}
            />
        );
    };

    return (
        <Controller
            name={name}
            control={control}
            // rules={rules}
            defaultValue={label_type === 'date range' ? { start: '', end: '' } : ''}
            render={({ field, fieldState: { error } }) => (

                <Form.Group className="mb-3 focus-z-index position-relative">
                    <Form.Label>
                        {isRequired && isImportant ? (
                            <>
                                <span className="text-danger">{label_name}</span>
                                <span className="text-danger ms-1">*</span>
                                <span> <i className="bi bi-exclamation-triangle text-warning ps-1"></i></span>

                            </>
                        ) : isImportant ? (
                            <>
                                <span className="text-danger">{label_name}</span>
                                <span> <i className="bi bi-exclamation-triangle text-warning ps-1"></i></span>
                            </>
                        ) : isRequired ? (
                            <>
                                {label_name}
                                <span className="text-danger ms-1">*</span>
                            </>
                        ) : (
                            label_name
                        )}
                    </Form.Label>
                    <InputGroup>{renderDateInput(field, error, label_type)}</InputGroup>
                    {/* {fieldState.error && <p style={{ fontSize: "12px" }} className="text-danger mt-1">{fieldState.error.message}</p>} */}
                    {error?.end && <p style={{ fontSize: "12px" }} className="text-danger mt-1">{error?.end?.message}</p>}
                    {error?.start && <p style={{ fontSize: "12px" }} className="text-danger mt-1">{error?.start?.message}</p>}
                    {error?.message && <p style={{ fontSize: "12px" }} className="text-danger mt-1">{error?.message}</p>}
                </Form.Group>
            )}
        />
    );
};

// ---------------- TIME ----------------
export const Time = ({
    name,
    label_name,
    rules,
    isRequired,
    control,
    isImportant,
    label_type
}) => {
    const renderTimeInput = (field, fieldState, labelType) => {
        // console.log(field, fieldState, labelType, rules)
        if (labelType === 'time-range') {
            return (
                <div className="d-flex gap-2 align-items-center">
                    <Form.Control
                        type="time"
                        value={field.value?.start || ''}
                        onChange={(e) => field.onChange({ ...field.value, start: e.target.value })}
                    />
                    <span className="text-muted">to</span>
                    <Form.Control
                        type="time"
                        value={field.value?.end || ''}
                        onChange={(e) => field.onChange({ ...field.value, end: e.target.value })}
                    />
                </div>
            );
        }

        return (
            <Form.Control
                type="time"
                value={field.value || ''}
                onChange={(e) => field.onChange(e.target.value)}
            />
        );
    };

    return (
        <Controller
            name={name}
            control={control}
            // rules={rules}
            // rules={isRequired === true || isRequired === "yes" ? rules : {}}
            defaultValue={label_type === 'time-range' ? { start: '', end: '' } : ''}
            render={({ field, fieldState: { error } }) => (
                <Form.Group className="mb-3 focus-z-index position-relative">
                    <Form.Label>
                        {isRequired && isImportant ? (
                            <>
                                <span className="text-danger">{label_name}</span>
                                <span className="text-danger ms-1">*</span>
                                <span> <i className="bi bi-exclamation-triangle text-warning ps-1"></i></span>

                            </>
                        ) : isImportant ? (<>
                            <span className="text-danger">{label_name}</span>
                            <span> <i className="bi bi-exclamation-triangle text-warning ps-1"></i></span>
                        </>
                        ) : isRequired ? (
                            <>
                                {label_name}
                                <span className="text-danger ms-1">*</span>
                            </>
                        ) : (
                            label_name
                        )}
                    </Form.Label>
                    <InputGroup>{renderTimeInput(field, error, label_type)}</InputGroup>
                    {error?.end && <p style={{ fontSize: "12px" }} className="text-danger mt-1">{error?.end?.message}</p>}
                    {error?.start && <p style={{ fontSize: "12px" }} className="text-danger mt-1">{error?.start?.message}</p>}
                    {error?.message && <p style={{ fontSize: "12px" }} className="text-danger mt-1">{error?.message}</p>}
                </Form.Group>
            )}
        />
    );
};

// ---------------- MULTIPLE-OPTION ----------------
// export const MultipleOpt = ({
//     name,
//     label_name,
//     isRequired,
//     options,
//     control,
//     rules,
// }) => {
//     const [dropdownOpen, setDropdownOpen] = useState(false);
//     const dropdownRef = useRef(null);

//     // Auto-parse options safely
//     const safeOptions = Array.isArray(options)
//         ? options
//         : (() => {
//             try {
//                 return JSON.parse(options) || [];
//             } catch {
//                 return [];
//             }
//         })();

//     useEffect(() => {
//         const handleClickOutside = (event) => {
//             if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//                 setDropdownOpen(false);
//             }
//         };
//         document.addEventListener("mousedown", handleClickOutside);
//         return () => document.removeEventListener("mousedown", handleClickOutside);
//     }, []);

//     return (
//         <Controller
//             name={name}
//             control={control}
//             rules={rules}
//             defaultValue={[]}
//             render={({ field, fieldState }) => {
//                 const selected = Array.isArray(field.value) ? field.value : [];

//                 const handleSelect = (val) => {
//                     if (!selected.includes(val)) {
//                         field.onChange([...selected, val]);
//                     }
//                     setDropdownOpen(false);
//                 };

//                 const removeOption = (val) => {
//                     field.onChange(selected.filter((v) => v !== val));
//                 };

//                 const available = safeOptions.filter((opt) => !selected.includes(opt.option));

//                 return (
//                     <Form.Group className="mb-3 focus-z-index position-relative" ref={dropdownRef}>
//                         <Form.Label>
//                             {label_name} {isRequired && <span className="text-danger ms-1">*</span>}
//                         </Form.Label>
//                         <div
//                             className={`form-control d-flex flex-wrap align-items-start ${fieldState.error ? "is-invalid" : ""}`}
//                             style={{ minHeight: "38px", padding: "6px 12px", gap: "6px", cursor: "pointer" }}
//                             onClick={() => setDropdownOpen(!dropdownOpen)}
//                         >
//                             {selected.map((val) => {
//                                 const fullOpt = safeOptions.find((o) => o.option === val);
//                                 return (
//                                     <span key={fullOpt?.sequence || val} className="option-badge d-inline-flex align-items-center"
//                                         style={{ background: "#7a3a5e", color: "white", padding: "2px 8px", borderRadius: "4px" }}
//                                         onClick={(e) => { e.stopPropagation(); removeOption(val); }}>
//                                         {val}
//                                         <IconX stroke={2} style={{ width: "14px", height: "14px", marginLeft: "6px" }} />
//                                     </span>
//                                 );
//                             })}
//                             {selected.length === 0 && <span className="text-muted">Select {label_name}</span>}
//                         </div>
//                         {dropdownOpen && (
//                             <div className="dropdown-menu show mt-1" style={{ maxHeight: "150px", width: '350px', overflowY: "auto" }}>
//                                 {available.length === 0
//                                     ? <div className="dropdown-item text-muted">No more {label_name} available</div>
//                                     : available.map((opt) => (
//                                         <div key={opt.sequence} className="dropdown-item" onClick={() => handleSelect(opt.option)}>
//                                             {opt.option}
//                                         </div>
//                                     ))}
//                             </div>
//                         )}
//                         {fieldState.error && <div className="invalid-feedback d-block" style={{ fontSize: "12px" }}>{fieldState.error.message}</div>}
//                     </Form.Group>
//                 );
//             }}
//         />
//     );
// };

export const MultipleOpt = ({
    name,
    label_name,
    isRequired,
    isImportant,
    options,
    control,
    rules,
}) => {

    // Safe parse options → [{option:"..", sequence:1}]
    const safeOptions = Array.isArray(options)
        ? options
        : (() => {
            try {
                return JSON.parse(options) || [];
            } catch {
                return [];
            }
        })();

    // React Select required format
    const formattedOptions = safeOptions.map((opt) => ({
        value: opt.option,
        label: opt.option,
    }));

    return (
        <Controller
            name={name}
            control={control}
            rules={rules}
            defaultValue={[]}
            render={({ field, fieldState }) => (
                <Form.Group className=" mb-3 focus-z-index position-relative">
                    <Form.Label>
                        {isRequired && isImportant ? (
                            <>
                                <span className="text-danger">{label_name}</span>
                                <span className="text-danger ms-1">*</span>
                                <span> <i className="bi bi-exclamation-triangle text-warning ps-1"></i></span>

                            </>
                        ) : isImportant ? (
                            <>    <span className="text-danger">{label_name}</span>
                                <span> <i className="bi bi-exclamation-triangle text-warning ps-1"></i></span>
                            </>
                        ) : isRequired ? (
                            <>
                                {label_name}
                                <span className="text-danger ms-1">*</span>
                            </>
                        ) : (
                            label_name
                        )}
                    </Form.Label>

                    <Select
                        {...field}
                        isMulti
                        placeholder={`Select ${label_name}`}
                        options={formattedOptions}
                        value={formattedOptions.filter((item) =>
                            field.value?.includes(item.value)
                        )}
                        onChange={(selected) =>
                            field.onChange(selected.map((s) => s.value))
                        }
                        styles={customStyles}
                        classNamePrefix="react-select"
                        className={fieldState.error ? "is-invalid" : ""}
                    />

                    {fieldState.error && (
                        <div className="invalid-feedback d-block" style={{ fontSize: "12px" }}>
                            {fieldState.error.message}
                        </div>
                    )}
                </Form.Group>
            )}
        />
    );
};


// ---------------- PHONE ----------------
export const PhoneNumberInput = ({
    name,
    label_name,
    rules,
    isRequired,
    isImportant,
    control,
    validatePhoneNumber,
    defaultCountry = "in",
}) => (
    <Controller
        name={name}
        control={control}
        rules={rules}
        render={({ field, fieldState }) => {
            const isInvalid = field.value && !validatePhoneNumber?.(field.value, defaultCountry);
            return (
                <Form.Group className="mb-3 focus-z-index position-relative">
                    <Form.Label>
                        {isRequired && isImportant ? (
                            <>
                                <span className="text-danger">{label_name}</span>
                                <span className="text-danger ms-1">*</span>
                                <span> <i className="bi bi-exclamation-triangle text-warning ps-1"></i></span>

                            </>
                        ) : isImportant ? (
                            <>    <span className="text-danger">{label_name}</span>
                                <span> <i className="bi bi-exclamation-triangle text-warning ps-1"></i></span>    </>
                        ) : isRequired ? (
                            <>
                                {label_name}
                                <span className="text-danger ms-1">*</span>
                            </>
                        ) : (
                            label_name
                        )}
                    </Form.Label>
                    <PhoneInput
                        value={field.value}
                        country={defaultCountry}
                        countryCodeEditable={false}
                        buttonStyle={{ border: "none" }}
                        inputStyle={{ width: "390px", height: "40px", border: fieldState.invalid ? "1px solid #dc3545" : "1px solid #c5c5c5" }}
                        containerStyle={{ borderRadius: "5px" }}
                        onChange={(value) => field.onChange(value)}
                    />
                    {isInvalid && <p style={{ fontSize: "12px" }} className="mt-1 text-danger">Phone is Invalid!</p>}
                    {fieldState.error && <p style={{ fontSize: "12px" }} className="text-danger mt-1">{fieldState.error.message}</p>}
                </Form.Group>
            );
        }}
    />
);


export const ReportSelectOpt = ({
    name,
    label_name,
    label_type,
    options,
    control,
    rules,
    fieldName,
    placeholder
}) => {

    const getCurrentValue = (fieldValue) =>
        options?.find((opt) => opt.value === fieldValue) || null;

    const handleChange = (selected, onChange) =>
        onChange(selected?.value || "");
    return (
        <Controller
            name={name}
            control={control}
            rules={rules}
            render={({ field, fieldState }) => (
                <Form.Group className="mb-3 focus-z-index position-relative">
                    <Form.Label>
                        {fieldName}
                    </Form.Label>
                    <Select
                        styles={customStyles}
                        className="input-box-select"
                        options={options}
                        value={getCurrentValue(field.value)}
                        onChange={(sel) => handleChange(sel, field.onChange)}
                        onBlur={field.onBlur}
                        isClearable
                        isSearchable
                        placeholder={placeholder || `Select ${label_name}`}
                        classNamePrefix="react-select"
                    />
                    {fieldState.error && <div className="invalid-feedback d-block" style={{ fontSize: "12px" }}>{fieldState.error.message}</div>}
                </Form.Group>
            )}
        />
    );
};

